import type { PlanVersionSummary } from '@/lib/apiTypes'
import { affectedCount } from '@/features/plans/lib/counts'

/** `+add ~change −destroy ⟳replace` — destroys/replaces carry a warning tone. */
export function ActionChips({ v, size = '0.63rem' }: { v: PlanVersionSummary; size?: string }) {
  const chip = (n: number, sym: string, color: string, title: string) =>
    n > 0 ? <span title={title} style={{ fontFamily: 'var(--mono)', fontSize: size, color }}>{sym}{n}</span> : null
  const total = affectedCount(v) + v.noop_count
  if (total === 0) return <span style={{ fontFamily: 'var(--mono)', fontSize: size, color: 'var(--text3)' }}>no changes</span>
  return (
    <span style={{ display: 'inline-flex', gap: 8, alignItems: 'baseline', flexWrap: 'wrap' }}>
      {chip(v.add_count, '+', 'var(--green)', 'to add')}
      {chip(v.change_count, '~', 'var(--text2)', 'to change')}
      {chip(v.destroy_count, '−', 'var(--red)', 'to destroy')}
      {chip(v.replace_count, '⟳', 'var(--amber)', 'to replace')}
    </span>
  )
}
